module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_comment_01-9cdd279c4cb63543b1b95884375aea0c.webp";